// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-PoweredBy-module__poweredByContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    padding: 0.1rem;
    font-size: x-small;
}

.src-sidebar-PoweredBy-module__logoContainer {
    width: 7rem;
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/PoweredBy.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB","sourcesContent":[".poweredByContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 0.3rem;\n    padding: 0.1rem;\n    font-size: x-small;\n}\n\n.logoContainer {\n    width: 7rem;\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"poweredByContainer": `src-sidebar-PoweredBy-module__poweredByContainer`,
	"logoContainer": `src-sidebar-PoweredBy-module__logoContainer`
};
export default ___CSS_LOADER_EXPORT___;
